import { RegisterAuthGuard } from './../services/guards/register-auth.guard';
import { RegisterKiwisaverComponent } from './../components/features/register/register-kiwisaver.component';
import { RegisterDefaultComponent } from './../components/features/register/register-default.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { SidebarComponent } from '../components/shared/sidebar/sidebar.component';
import { ProfileComponent } from '../components/features/user/profile/profile.component';
import { AuthGuard } from '../services/guards/auth.guard';
import { NotFoundComponent } from '../components/features/not-found/not-found.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { SecurityPreferencesComponent, TFASettingsDialogComponent } from 'src/app/components/features/user/security-preferences/security-preferences.component';
import { RegisterComponent } from '../components/features/register/register.component';
import { LayoutModule } from '../layout/layout.module';
import { AdminisSharedModule } from '../components/shared/adminis-shared.module';
import { UtilsModule } from '../utils/utils.module';
import { FeatureGuardService } from '../services/guards/feature.guard';
import { Features } from '../models/features';
import { UnauthorisedComponent } from '../layout/unauthorised/unauthorised.component';
import { TaxDetailsComponent } from '../components/features/user/tax-details/tax-details.component';
import { AddressDetailsComponent } from '../components/features/user/address-details/address-details.component';
import { InvitationsComponent } from '../components/features/user/invitations/invitations.component';
import { BankAccountComponent } from '../components/features/client/bank-accounts/bank-accounts.component';
import {RegisterKiwisaverComponentV2} from "../components/features/register/register-kiwisaver-v2.component";


const appRoutes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./../components/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'registration',
    loadChildren: () => import('./../components/features/registration/registration.module').then(m => m.RegistrationModule)
  },
  {
    path: 'feature',
    loadChildren: () => import('./../components/features/features.module').then(m => m.FeaturesModule)
  },
  {
    path: 'profile',
    component: SidebarComponent,
    outlet: 'sidebar',
    canActivate: [AuthGuard],
    children: [
      { path: 'changePassword', redirectTo: 'auth/forgotpassword', pathMatch: 'full' },
      { path: 'changeTFA', component: SecurityPreferencesComponent, canActivate: [AuthGuard] },
      { path: 'taxDetails', component: TaxDetailsComponent, canActivate: [FeatureGuardService], data: { feature: Features.TAX_DETAILS } },
      { path: 'addressDetails', component: AddressDetailsComponent, canActivate: [FeatureGuardService], data: { feature: Features.ADDRESS_DETAILS }  },
      { path: 'invitations', component: InvitationsComponent },
      { path: 'bankAccounts', component: BankAccountComponent },
      { path: '', component: ProfileComponent, canActivate: [AuthGuard] },
      { path: '**', redirectTo: '' }
    ]
  },
  {
    path: 'register',
    component: UnauthorisedComponent,
    children: [
      { path: '', component: RegisterComponent, canActivate: [FeatureGuardService, RegisterAuthGuard], data: { feature: Features.REGISTRATION } }
    ]
  },
  { path: 'password', redirectTo: 'auth/resetpassword', pathMatch: 'full' },
  {
    path: 'invite',
    redirectTo: 'auth/resetpassword/true',
    pathMatch: 'full'
  },
  { path: '', redirectTo: 'auth/signin', pathMatch: 'full' },
  { path: '404', component: NotFoundComponent, canActivate: [AuthGuard] },
  { path: '**', redirectTo: '404' }
];

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AdminisSharedModule,
    HighchartsChartModule,
    UtilsModule,
    LayoutModule,
    RouterModule,
    RouterModule.forRoot(appRoutes, { enableTracing: false })
  ],
  declarations: [
    ProfileComponent,
    NotFoundComponent,
    RegisterDefaultComponent,
    RegisterKiwisaverComponent,
    RegisterKiwisaverComponentV2,
    RegisterComponent,
    SidebarComponent,
    SecurityPreferencesComponent,
    TFASettingsDialogComponent,
    TaxDetailsComponent,
    AddressDetailsComponent,
    InvitationsComponent
  ],
  exports: [
    RouterModule
  ],
  providers: [
    {
      provide: 'setPasswordResolver',
      useValue: () => true
    }
  ]
})
export class RoutesModule { }
